import { mapActions, mapGetters } from 'vuex'

let globalDraggingObject = null

export const DragAndDrop = {
  computed: {
    ...mapGetters(['getBoardPreviewOption', 'getStyleById'])
  },

  methods: {
    ...mapActions([
      'updateBoardIndex',
      'updateStyle',
      'updateOption',
      'updateDetail',
      'updateBoardIndexStoreOnly',
      'updateOptionIndexStoreOnly',
      'updateDetailIndexStoreOnly',
      'updateBoardPreviewOptionStoreOnly',
      'updateStyleStoreOnly'
    ]),

    /**
     * @param {object} draggedObject
     */
    startDragging (draggedObject) {
      if (globalDraggingObject || !draggedObject) {
        return
      }

      globalDraggingObject = draggedObject
    },

    /**
     * @returns {object}
     */
    getDraggingItem () {
      return globalDraggingObject
    },

    /**
     * @param   {object} dragData
     *
     * @returns {number}
     */
    async stopDraggingReorder (dragData) {
      const item = dragData.item
      const type = dragData.type
      const list = dragData.list
      const boardId = item.board_id
      const styleId = item.style_id
      const projectId = item.project_id
      const originIndex = item.index
      const destinationIndex = list[dragData.destinationIndex].index

      let direction = null

      if (originIndex < destinationIndex) {
        direction = 1
      } else {
        direction = -1
      }

      for (const listItem of list) {
        let newIndex = null

        if (direction === 1) {
          if (
            listItem.index <= destinationIndex &&
            listItem.index >= originIndex
          ) {
            newIndex = listItem.index - 1
          }
        }

        if (direction === -1) {
          if (
            listItem.index >= destinationIndex &&
            listItem.index <= originIndex
          ) {
            newIndex = listItem.index + 1
          }
        }

        if (listItem.id === item.id) {
          newIndex = destinationIndex
        }

        if (newIndex !== null) {
          this.updateIndexStoreOnly(listItem, newIndex, type)
        }
      }

      if (originIndex !== destinationIndex) {
        await this.preparePayloadAndSend(
          projectId,
          destinationIndex,
          boardId,
          null,
          styleId,
          type,
          item.id
        )
      }

      return item.id
    },

    /**
     * @param {object} item
     * @param {number} index
     * @param {string} type
     */
    updateIndexStoreOnly (item, index, type) {
      switch (type) {
        case 'board':
          this.updateBoardIndexStoreOnly({
            boardId: item.id,
            index: index
          })
          break
        case 'detail':
          this.updateDetailIndexStoreOnly({
            detailId: item.id,
            index: index
          })
          break
        case 'option':
          this.updateOptionIndexStoreOnly({
            optionId: item.id,
            index: index
          })
          break
      }
    },

    /**
     * @param   {object} dragData
     *
     * @returns {number}          lastActiveID
     */
    async stopDraggingSwap (dragData) {
      if (!globalDraggingObject) {
        return
      }

      if (!globalDraggingObject.id) {
        return
      }

      const originIndex = globalDraggingObject.index
      const destinationIndex = dragData.destination.index
      const destinationId = dragData.destination.id
      const type = dragData.type
      const newBoardId = dragData.boardId ? dragData.boardId : null
      const boardId = globalDraggingObject.board_id
        ? globalDraggingObject.board_id
        : null
      const styleId = globalDraggingObject.style_id
        ? globalDraggingObject.style_id
        : null
      let projectId = globalDraggingObject.project_id
        ? globalDraggingObject.project_id
        : null

      if (globalDraggingObject.projectId) {
        projectId = globalDraggingObject.projectId
      }

      if (type === 'style' && destinationId) {
        this.updateStyleStoreOnly({
          styleId: dragData.destination.id,
          boardId: boardId,
          index: originIndex
        })
      }

      const shouldMoveStyle =
        boardId === newBoardId ? originIndex !== destinationIndex : true

      if (shouldMoveStyle) {
        await this.preparePayloadAndSend(
          projectId,
          destinationIndex,
          boardId,
          newBoardId !== boardId ? newBoardId : null,
          styleId,
          type,
          globalDraggingObject.id
        )
      }

      const draggingObjectId = globalDraggingObject.id

      globalDraggingObject = null

      return draggingObjectId
    },

    /**
     * @param   {string} payloadType
     * @param   {object} payloadToSend
     *
     * @param   {number} projectId
     * @param   {number} index
     * @param   {number} boardId
     * @param   {number} newBoardId
     * @param   {number} styleId
     * @param   {string} type
     * @param   {number} itemId
     *
     * @returns {number}               lastActiveID
     */
    async preparePayloadAndSend (
      projectId,
      index,
      boardId,
      newBoardId,
      styleId,
      type,
      itemId
    ) {
      const payload = {
        index: index
      }

      if (projectId) {
        payload.projectId = projectId
      }

      if (boardId) {
        payload.boardId = boardId
      }

      if (newBoardId) {
        payload.newBoardId = newBoardId
      }

      if (styleId) {
        payload.styleId = styleId
      }

      if (type === 'board') {
        payload.boardId = itemId
      }

      if (type === 'style') {
        payload.styleId = itemId
      }

      if (type === 'option') {
        payload.optionId = itemId
      }

      if (type === 'detail') {
        payload.detailId = itemId
      }

      if (itemId) {
        await this.sendUpdatePayload(type, payload)
      }
    },

    /**
     * @param   {string} payloadType
     * @param   {object} payloadToSend
     *
     * @returns {number}               lastActiveID
     */
    async sendUpdatePayload (payloadType, payloadToSend) {
      if (payloadType === 'board') {
        await this.updateBoardIndex(payloadToSend)
      }

      if (payloadType === 'style') {
        await this.updateStyle(payloadToSend)
      }

      if (payloadType === 'option') {
        await this.updateOption(payloadToSend)
      }

      if (payloadType === 'detail') {
        await this.updateDetail(payloadToSend)
      }
    }
  }
}
